import { useNavigate } from 'react-router-dom';

import Styles from './WizardError.module.scss';

import { Button } from '@/components/Elements/Button';

export const WizardError = () => {
	const navigate = useNavigate();
	return (
		<div className={Styles.container}>
			<div className={Styles.icon}>
				<span>!</span>
			</div>
			<p>Something went wrong. Please try again later.</p>

			<Button
				variant="secondary"
				onClick={() => {
					navigate('/organizations', { replace: true });
				}}
			>
				Go to previous page
			</Button>
		</div>
	);
};
